export default "__VITE_ASSET__olGtmRvg__"